// Utilitários para API de customização de serviços
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Constantes do serviço de contestação
export const CONTESTATION_SERVICE = {
  CODE: 'DOCUMENT_CREATION_CONTESTATION',
  ATTRIBUTES: {
    PROFILE_PARAMS: 'PROFILE_PARAMS',
    RULES: 'RULES',
    RULES_INTERNAL: 'RULES_INTERNAL',
    DOCX_TEMPLATE_FILE: 'DOCX_TEMPLATE_FILE'
  }
};

/**
 * Lê o valor de um atributo customizado
 */
export const readServiceCustomization = async (token, cellId, attributeKey) => {
  try {
    const response = await fetch(`${API_BASE_URL}/job/service_customization/read`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        service_code: CONTESTATION_SERVICE.CODE,
        attribute_key: attributeKey,
        cell_id: cellId
      })
    });

    if (!response.ok) {
      throw new Error(`Erro ao ler atributo: ${response.status}`);
    }

    const data = await response.json();
    return data.value;
  } catch (error) {
    console.error(`Erro ao ler atributo ${attributeKey}:`, error);
    return null;
  }
};

/**
 * Verifica se um atributo customizado existe
 */
export const checkServiceCustomizationExists = async (token, cellId, attributeKey) => {
  try {
    const response = await fetch(`${API_BASE_URL}/job/service_customization/exists`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        service_code: CONTESTATION_SERVICE.CODE,
        attribute_key: attributeKey,
        cell_id: cellId
      })
    });

    if (!response.ok) {
      throw new Error(`Erro ao verificar existência: ${response.status}`);
    }

    const data = await response.json();
    return data.exists;
  } catch (error) {
    console.error(`Erro ao verificar existência do atributo ${attributeKey}:`, error);
    return false;
  }
};

/**
 * Escreve/atualiza o valor de um atributo customizado
 */
export const writeServiceCustomization = async (token, cellId, attributeKey, attributeValue) => {
  try {
    const response = await fetch(`${API_BASE_URL}/job/service_customization/write`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        service_code: CONTESTATION_SERVICE.CODE,
        attribute_key: attributeKey,
        attribute_value: attributeValue,
        cell_id: cellId
      })
    });

    if (!response.ok) {
      throw new Error(`Erro ao salvar atributo: ${response.status}`);
    }

    const data = await response.json();
    return data.success;
  } catch (error) {
    console.error(`Erro ao salvar atributo ${attributeKey}:`, error);
    return false;
  }
};

/**
 * Remove um atributo customizado
 */
export const deleteServiceCustomization = async (token, cellId, attributeKey) => {
  try {
    const response = await fetch(`${API_BASE_URL}/job/service_customization/delete`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        service_code: CONTESTATION_SERVICE.CODE,
        attribute_key: attributeKey,
        cell_id: cellId
      })
    });

    if (!response.ok) {
      throw new Error(`Erro ao deletar atributo: ${response.status}`);
    }

    const data = await response.json();
    return data.deleted;
  } catch (error) {
    console.error(`Erro ao deletar atributo ${attributeKey}:`, error);
    return false;
  }
};

/**
 * Converte arquivo para base64
 */
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Remove o prefixo "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,"
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = error => reject(error);
  });
};

/**
 * Converte base64 para blob para download
 */
export const base64ToBlob = (base64, mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
};

/**
 * Faz download de um arquivo a partir de base64
 */
export const downloadBase64File = (base64, filename) => {
  const blob = base64ToBlob(base64);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

